import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import Layout from './Components/Layout';
import SdaHomes from './Components/SdaHomes';
import HomePage from './Components/HomePage';
import AboutUs from './Components/AboutUs';
import AdminLogin from './Components/Admin/AdminLogin';
import AdminDashboard from './Components/Admin/AdminDashboard';
import AdminCreatePost from './Components/Admin/AdminCreatePost';
import AdminEditPost from './Components/Admin/AdminEditPost';
import CreateHome from './Components/Admin/CreateHome';
import EditHome from './Components/Admin/EditHome';
import ViewPost from './Components/ViewPost';
import ViewHome from './Components/ViewHome';
import Properties from './Components/Properties';
import InHomeSupport from './Components/InHomeSupport';
import Community from './Components/Community';
import Respite from './Components/Respite';
import NewsAndBlogs from './Components/NewsAndBlogs';
import HomeFinder from './Components/HomeFinder';
import Resources from './Components/Resources';
import ContactUs from './Components/ContanctUs';
import AdminCreateCareer from './Components/Admin/AdminCreateCareer';
import AdminEditCareer from './Components/Admin/AdminEditCareer';
import Careers from './Components/Careers';
import CareerDetails from './Components/CareerDetails';
import OurTeam from './Components/OurTeam';
import TeamMemberDetail from './Components/TeamMemberDetail';
import ScrollToTop from "./Components/ScrollToTop"; // Import the ScrollToTop component

function App() {
    return (
        <HelmetProvider>
            <Helmet>
                <title>Livability Care</title>
            </Helmet>
            <Router>
                <ScrollToTop /> {/* Add this inside Router */}
                <Layout>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/sda-homes" element={<SdaHomes />} />
                        <Route path="/about-us" element={<AboutUs />} />
                        <Route path="/our-team" element={<OurTeam />} />
                        <Route path="/news" element={<NewsAndBlogs />} />
                        <Route path="/resources" element={<Resources />} />
                        <Route path="/contact" element={<ContactUs />} />
                        <Route path="/properties" element={<HomeFinder />} />
                        <Route path="/services/inhome-support" element={<InHomeSupport />} />
                        <Route path="/services/community" element={<Community />} />
                        <Route path="/services/respite" element={<Respite />} />
                        <Route path="/properties" element={<Properties />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin/dashboard" element={<AdminDashboard />} />
                        <Route path="/admin/createpost" element={<AdminCreatePost />} />
                        <Route path="/admin/editpost/:id" element={<AdminEditPost />} />
                        <Route path="/admin/createhome" element={<CreateHome />} />
                        <Route path="/admin/edithome/:homeId" element={<EditHome />} />
                        <Route path="/ViewPost/:id" element={<ViewPost />} />
                        <Route path="/ViewHome/:id" element={<ViewHome />} />
                        <Route path="/careers" element={<Careers />} />
                        <Route path="/careers/:id" element={<CareerDetails />} />
                        <Route path="/admin/createcareer" element={<AdminCreateCareer />} />
                        <Route path="/admin/editcareer/:id" element={<AdminEditCareer />} />
                        <Route path="/team/:name" element={<TeamMemberDetail />} />
                    </Routes>
                </Layout>
            </Router>
        </HelmetProvider>
    );
}

export default App;